<template>
  <div>
    <Menu />
    <div class="container main atualizar-cadastro">
      <ValidationObserver ref="form">
        <div class="row">
          <div class="col-md-12">
            <SectionTitle
              title="Atualizar cadastro"
              description="Atualizar dados e alterar senha"
              url="/dashboard"
            />
          </div>

          <!-- SPINNER -->
          <div
            v-if="loadingUser"
            class="col-12 d-flex flex-column align-items-center justify-content-center py-5"
          >
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Carregando..."
            ></b-spinner>

            <span class="mt-3 text-muted">
              Carregando dados do usuário...
            </span>
          </div>

          <div v-else class="col-12">
            <div class="row">
              <div class="col-md-6 col-12">
                <validation-provider v-slot="{ errors }" rules="email">
                  <div class="error">{{ errors[0] }}</div>
                  <label for="">E-MAIL</label>
                  <div class="form-group input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icofont-envelope"></i>
                      </span>
                    </div>
                    <input
                      name="email"
                      v-model="email"
                      class="form-control"
                      placeholder="E-MAIL"
                      type="email"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="col-md-6 col-12">
                <validation-provider v-slot="{ errors }" rules="phone">
                  <div class="error">{{ errors[0] }}</div>
                  <label for="">TELEFONE</label>
                  <div class="form-group input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icofont-phone"></i>
                      </span>
                    </div>
                    <the-mask
                      :mask="['(##) ####-####', '(##) #####-####']"
                      v-model="telefone"
                      required
                      class="form-control"
                      placeholder="TELEFONE"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="col-md-6 col-12">
                <validation-provider v-slot="{ errors }" rules="password">
                  <!-- <div class="error">{{ errors[0] }}</div> -->
                  <label for="">NOVA SENHA</label>
                  <div class="form-group input-group">
                    <div
                      class="input-group-prepend"
                      @click="showPassword = !showPassword"
                      style="cursor: pointer"
                    >
                      <span class="input-group-text">
                        <i
                          :class="
                            showPassword ? 'icofont-eye-blocked' : 'icofont-eye'
                          "
                        ></i>
                      </span>
                    </div>
                    <input
                      name="senha"
                      v-model="senha"
                      class="form-control"
                      placeholder=""
                      :type="showPassword ? 'text' : 'password'"
                    />
                  </div>
                  <div class="mt-2 mb-2">
                    <ul>
                      <li :class="colorLenght">
                        <i :class="lenghtPassword"></i> 8 ou mais caracteres;
                      </li>
                      <li :class="colorLetters">
                        <i :class="lettersPassword"></i> 1 ou mais letras
                        maiúsculas;
                        <span
                          v-b-tooltip.hover
                          title="A B C D E F G H I J K L M N O P Q R S T U V W X Y Z"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </li>
                      <li :class="colorNumbers">
                        <i :class="numbersPassword"></i> 1 ou mais números;
                        <span
                          v-b-tooltip.hover
                          title="1 2 3 4 5 6 7 8 9 0"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </li>
                      <li :class="colorSpecialChars">
                        <i :class="SpecialCharsPassword"></i> 1 ou mais
                        caracteres especiais.
                        <span
                          v-b-tooltip.hover
                          title="Exemplos de caracteres especiais: ! @ # $ % ^ & * ( ) _ + \ - = [ \ ] { } ; : \ \ | , . < > / ? ~"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </validation-provider>
              </div>
              <div class="col-md-6 col-12">
                <validation-provider v-slot="{ errors }" rules="password">
                  <!-- <div class="error">{{ errors[0] }}</div> -->
                  <label for="">CONFIRMAR NOVA SENHA</label>
                  <div class="form-group input-group">
                    <div
                      class="input-group-prepend"
                      @click="showConfirmedPassword = !showConfirmedPassword"
                    >
                      <span class="input-group-text">
                        <i
                          :class="
                            showConfirmedPassword
                              ? 'icofont-eye-blocked'
                              : 'icofont-eye'
                          "
                        ></i>
                      </span>
                    </div>
                    <input
                      name="confirmarsenha"
                      v-model="confirmarsenha"
                      class="form-control"
                      placeholder=""
                      :type="showConfirmedPassword ? 'text' : 'password'"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      id="nao_receber_msg"
                      v-model="nao_receber_msg"
                      type="checkbox"
                      class="custom-control-input"
                    />

                    <label class="custom-control-label" for="nao_receber_msg">
                      Não receber mensagens pelo WhatsApp
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="d-flex flex-column align-items-center justify-content-center mb-4"
                >
                  <span class="mb-2">Foto do perfil (opcional)</span>

                  <div class="avatar-wrapper" @click="triggerAvatarSelect">
                    <div class="avatar-uploader">
                      <img
                        v-if="avatarPreview"
                        :src="avatarPreview"
                        alt="Foto do perfil"
                        class="avatar-img"
                      />
                      <div v-else class="avatar-placeholder">
                        <i class="icofont-ui-user"></i>
                        <small>Foto</small>
                      </div>
                    </div>

                    <!-- badge câmera -->
                    <div class="avatar-badge">
                      <i class="icofont-camera"></i>
                    </div>

                    <!-- botão remover -->
                    <button
                      v-if="avatarPreview"
                      type="button"
                      class="avatar-remove"
                      @click.stop="removerAvatar"
                      aria-label="Remover foto"
                      title="Remover foto"
                    >
                      <i class="icofont-close"></i>
                    </button>
                  </div>

                  <input
                    ref="avatarInput"
                    type="file"
                    accept="image/jpeg,image/png"
                    class="d-none"
                    @change="onAvatarSelected"
                  />
                </div>
              </div>

              <div class="col-12">
                <button
                  type="submit"
                  class="btn float-right"
                  style="color: #fff"
                  v-on:click="atualizar()"
                >
                  Atualizar
                  <b-spinner
                    label="Spinning"
                    small
                    variant="white"
                    v-if="loading"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import { TheMask } from 'vue-the-mask'
import { mapState } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import SectionTitle from '@/components/SectionTitle'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  name: 'AtualizarCadastro',
  components: {
    Menu,
    Footer,
    TheMask,
    PulseLoader,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      cidades: [],
      estado: '',
      cidade: '',
      nome: '',
      cpf: '',
      email: '',
      funcao: '',
      telefone: '',
      senha: '',
      confirmarsenha: '',
      avatarFile: null,
      avatarPreview: null,
      avatarRemovido: false,
      loadingUser: true,
      loading: false,
      showPassword: false,
      showConfirmedPassword: false,
      nao_receber_msg: false,
    }
  },
  created() {
    this.buscarUsuario()
  },
  computed: {
    colorLenght() {
      if (this.senha.length < 8) {
        return 'red'
      }
      return 'green'
    },
    lenghtPassword() {
      if (this.senha.length < 8) {
        return 'icofont-close'
      }
      return 'icofont-check'
    },
    colorNumbers() {
      if (/\d/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    numbersPassword() {
      if (/\d/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorLetters() {
      if (/[A-Z]/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    lettersPassword() {
      if (/[A-Z]/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorSpecialChars() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    SpecialCharsPassword() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
  },
  methods: {
    /**
     * Manipula para trocar o avatar
     */
    triggerAvatarSelect() {
      this.$refs.avatarInput && this.$refs.avatarInput.click()
    },

    /**
     * Manipula ao selecionar um avatar
     *
     * @param {File} e
     */
    onAvatarSelected(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return

      // SOMENTE JPG/JPEG/PNG e < 1MB
      const allowed = ['image/jpeg', 'image/png']
      const maxSizeBytes = 1 * 1024 * 1024

      if (!allowed.includes(file.type)) {
        this.$toast.error('Selecione uma imagem JPG/JPEG ou PNG.', 'Erro:', {
          position: 'topRight',
        })
        e.target.value = ''
        return
      }

      if (file.size > maxSizeBytes) {
        this.$toast.error('A imagem deve ter no máximo 1MB.', 'Erro:', {
          position: 'topRight',
        })
        e.target.value = ''
        return
      }

      this.avatarFile = file
      this.avatarRemovido = false

      // preview local
      if (this.avatarPreview && this.avatarPreview.startsWith('blob:')) {
        URL.revokeObjectURL(this.avatarPreview)
      }
      this.avatarPreview = URL.createObjectURL(file)
    },

    /**
     * Remove o avatar
     */
    removerAvatar() {
      this.avatarFile = null
      this.avatarRemovido = true

      if (this.avatarPreview && this.avatarPreview.startsWith('blob:')) {
        URL.revokeObjectURL(this.avatarPreview)
      }
      this.avatarPreview = null

      if (this.$refs.avatarInput) {
        this.$refs.avatarInput.value = ''
      }
    },

    /**
     * Busca os dados do usuário
     */
    buscarUsuario() {
      this.loadingUser = true
      this.$api
        .get('/app/usuario/' + this.$store.state.id)
        .then((response) => {
          this.estado = response.data.no_uf
          this.cidade = response.data.cod_ibge
          this.nome = response.data.nome
          this.cpf = response.data.cpf
          this.email = response.data.email
          this.funcao = response.data.funcao
          this.telefone = response.data.telefone
          this.nao_receber_msg = Number(response.data.nao_receber_msg) === 1

          if (response.data.foto_perfil != null) {
            this.avatarPreview = `https://esusfeedback.com.br/api/uploads/usuarios/${response.data.foto_perfil}`
          } else {
            this.avatarPreview = null
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.loadingUser = false
        })
    },

    /**
     * Atualiza o usuário
     */
    async atualizar() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) return false

      if (this.senha !== this.confirmarsenha) {
        this.$toast.error('As senhas não conferem!', 'Error:', {
          position: 'topRight',
        })
        return
      }

      this.loading = true

      const fd = new FormData()
      fd.append('id', this.$store.state.id)
      // fd.append('nome', this.nome || '')
      fd.append('email', this.email || '')
      fd.append('telefone', this.telefone || '')
      fd.append('senha', this.senha || '')
      // manda arquivo só se existir
      if (this.avatarFile) {
        fd.append('foto_perfil', this.avatarFile)
      }
      // informa remoção se o usuário deletar a foto
      fd.append('remover_foto', this.avatarRemovido ? '1' : '0')
      fd.append('nao_receber_msg', this.nao_receber_msg ? '1' : '0')

      this.$api
        .post('/app/atualizar-usuario', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.error) {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
          } else {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$toast.error(
            'Por favor, entre em contato com o suporte.',
            'Error:',
            {
              position: 'topRight',
            }
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  beforeDestroy() {
    if (this.avatarPreview && this.avatarPreview.startsWith('blob:')) {
      URL.revokeObjectURL(this.avatarPreview)
    }
  },
}
</script>

<style lang="scss" scoped>
.atualizar-cadastro {
  // Avatar do usuário
  .avatar-wrapper {
    position: relative;
    width: 110px;
    height: 110px;
    cursor: pointer;

    .avatar-uploader {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border: 2px dashed #cfd6dc;
      border-radius: 50%;
      background: #f7f9fb;

      &:hover {
        border-color: #0d98bb;
      }

      .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .avatar-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #6c757d;

        i {
          font-size: 32px;
        }

        small {
          margin-top: 10px;
          font-size: 12px;
        }
      }
    }

    // Ícone da câmera
    .avatar-badge {
      position: absolute;
      right: 10px;
      bottom: -4px;
      z-index: 5;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border: 2px solid #fff;
      border-radius: 50%;
      background: #0d98bb;
      color: #fff;

      i {
        font-size: 16px;
      }
    }

    // Botão de remover foto
    .avatar-remove {
      position: absolute;
      top: -6px;
      right: -6px;
      z-index: 6;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      padding: 0;
      border: 2px solid #fff;
      border-radius: 50%;
      background: #dc3545;
      color: #fff;
      cursor: pointer;

      i {
        font-size: 14px;
      }

      &:hover {
        filter: brightness(0.95);
      }
    }
  }
}
</style>
